export default {"src":"/_next/static/media/JNJ.0cc260ec.svg","height":18,"width":18};